module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldCond.3c074eb.eot";